import { Dispatch, SetStateAction, useState } from "react";
import "./AnimatedEyeIcon.css";

interface EyeIconProps {
  size?: number;
  color?: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const EyeIcon = ({ size = 50, color = "black", isOpen, setIsOpen }: EyeIconProps) => {

  const toggleEye = () => setIsOpen(!isOpen);

  return (
    <button
      type="button"
      className={`eye-icon ${isOpen ? "eye-open" : "eye-close"}`}
      onClick={toggleEye}
      style={{ width: size, height: size }}
      aria-label="Toggle Eye"
    >
      <svg
        viewBox="-20 -200 320 400"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
      >
        <g id="eye" strokeWidth="25" fill="none" stroke={color}>
          <g id="eye-lashes">
            <line x1="140" x2="140" y1="90" y2="180" />
            <line x1="70" x2="10" y1="60" y2="140" />
            <line x1="210" x2="270" y1="60" y2="140" />
          </g>
          <path id="eye-bottom" d="m0,0q140,190 280,0" />
          <path id="eye-top" d="m0,0q140,190 280,0" />
          <circle id="eye-pupil" cx="140" cy="0" r="40" fill={color} stroke="none" />
        </g>
      </svg>
    </button>
  );
};

export default EyeIcon;
